import { Component, EventEmitter, Output } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { Router } from '@angular/router'
import { AuthService } from '../../services/auth.service'
import { MessageService } from 'primeng/api'
import { TranslateService } from '@ngx-translate/core'
import { environment } from 'src/config/environments/environment'

@Component({
  selector: 'app-org-finder',
  templateUrl: './org-finder.component.html',
  styleUrls: ['./org-finder.component.scss'],
  standalone: false,
})
export class OrgFinderComponent {
  @Output() closed = new EventEmitter<void>()

  visible: boolean = false
  form: FormGroup
  loading: boolean = false

  get isRTL(): boolean {
    return this.translate.currentLang === 'he' || this.translate.currentLang === 'ar'
  }

  constructor(private fb: FormBuilder, private router: Router, private authService: AuthService, private messageService: MessageService, public translate: TranslateService) {
    this.form = this.fb.group({
      orgCode: ['', [Validators.required, Validators.pattern(/^[a-z0-9-]+$/)]],
    })
  }

  open() {
    this.visible = true
    this.form.reset()
  }

  closeDialog() {
    this.visible = false
    this.closed.emit()
  }

  async continue() {
    if (this.form.invalid) {
      this.messageService.add({
        severity: 'error',
        summary: this.translate.instant('AUTH.ERRORS.INVALID_ORG_CODE.TITLE'),
        detail: this.translate.instant('AUTH.ERRORS.INVALID_ORG_CODE.MESSAGE'),
      })
      return
    }

    this.loading = true
    const orgCode = (this.form.value as { orgCode: string }).orgCode.toLowerCase()

    try {
      // Check if organization exists
      const orgInfo = await this.authService.checkOrgExists(orgCode)

      if (orgInfo.exists) {
        this.closeDialog()

        // If SAML is enabled, redirect directly to SAML login endpoint
        if (orgInfo.saml_enabled || orgInfo.samlEnabled) {
          const origin = window.location.origin
          window.location.href = `${environment.serverUrl}/auth/saml/login?clientId=${orgCode}&origin=${encodeURIComponent(origin)}`
        } else {
          // Standard login for non-SAML orgs
          this.router.navigate(['/org', orgCode, 'auth', 'login'])
        }
      } else {
        this.messageService.add({
          severity: 'error',
          summary: this.translate.instant('AUTH.ERRORS.ORG_NOT_FOUND.TITLE'),
          detail: this.translate.instant('AUTH.ERRORS.ORG_NOT_FOUND.MESSAGE'),
        })
      }
    } catch (_error) {
      this.messageService.add({
        severity: 'error',
        summary: this.translate.instant('AUTH.ERRORS.ORG_CHECK_FAILED.TITLE'),
        detail: this.translate.instant('AUTH.ERRORS.ORG_CHECK_FAILED.MESSAGE'),
      })
    } finally {
      this.loading = false
    }
  }
}
